import { all, call, spawn } from 'redux-saga/effects';
import session from './session';
import dataFetchingSagas from './data/sagas';
import { watchGetOTAInsightsByDay } from 'legacy/main/sagas/propertySaga';
import {
    watchGetOTAInsightsByRange,
    watchGetRecommendationsForRange,
    watchGetEventsForRange,
} from 'legacy/main/sagas/dashBoardSaga';
import { watchGetPropertyByYear } from 'legacy/main/sagas/yearViewSaga';
import { watchGetPropertyByMonth } from 'legacy/main/sagas/monthViewSaga';
import { watchGetEventsForDay } from 'legacy/main/sagas/dayViewSaga';

/**
 * Root saga, containing all sagas that must execute continuously
 * As opposed to the saga dynamically injected when certain components mount,
 * because they aren't required to run when the component does not exist.
 *
 * This template of root saga is described in the redux-saga documentation:
 * https://github.com/redux-saga/redux-saga/blob/master/docs/advanced/RootSaga.md#keeping-everything-alive
 *
 * The spawn effect allows for a saga to fail without failing the parent (i.e. the global app saga).
 * The `while (true)` loop allows to restart saga on crash, and logs any failure to help debugging
 *
 * @return {Generator}
 */
export default function* rootSaga() {
    const sagas = [
        session.saga,
        ...dataFetchingSagas,
        // Legacy sagas
        watchGetPropertyByYear,
        watchGetPropertyByMonth,
        watchGetOTAInsightsByDay,
        watchGetRecommendationsForRange,
        watchGetOTAInsightsByRange,
        watchGetEventsForDay,
        watchGetEventsForRange,
    ];

    yield all(
        sagas.map((saga) =>
            spawn(function* spawnedSaga() {
                while (true) {
                    try {
                        yield call(saga);
                        break;
                    } catch (e) {
                        console.warn(e); // eslint-disable-line no-console
                    }
                }
            }),
        ),
    );
}
